/**
 * Color constants for heat map visualization
 * Maps percentage ranges to colors for zone activity visualization
 */

export const HEATMAP_COLORS = {
  /** Light blue - default/empty zones (0%) */
  EMPTY: "#c4cdf6",
  /** Dark blue - very low activity (1-15%) */
  VERY_LOW: "#1C066B",
  /** Purple - low activity (16-30%) */
  LOW: "#481FDA",
  /** Light purple - medium-low activity (31-45%) */
  MEDIUM_LOW: "#7957F2",
  /** Light red - medium-high activity (46-60%) */
  MEDIUM_HIGH: "#FD8789",
  /** Medium red - high activity (61-75%) */
  HIGH: "#DA4346",
  /** Dark red - very high activity (76-100%) */
  VERY_HIGH: "#EA0E11",
} as const;

/**
 * Zone boundary constants for baseball strike zone mapping
 * All values are in backend coordinate system (-10 to 10)
 */

// Inner zone boundaries
export const INNER_ZONE_TOP_EDGE_Y = 6.78;
export const INNER_ZONE_BOTTOM_EDGE_Y = -6.79;
export const INNER_ZONE_LEFT_EDGE_X = -6.78;
export const INNER_ZONE_RIGHT_EDGE_X = 6.78;

// Inner zone row boundaries
export const INNER_TOP_ROW_MIN_Y = 2.27;
export const INNER_TOP_ROW_MAX_Y = INNER_ZONE_TOP_EDGE_Y;

export const INNER_MIDDLE_ROW_MIN_Y = -2.26;
export const INNER_MIDDLE_ROW_MAX_Y = 2.26;

export const INNER_BOTTOM_ROW_MIN_Y = INNER_ZONE_BOTTOM_EDGE_Y;
export const INNER_BOTTOM_ROW_MAX_Y = -2.27;

// Inner zone column boundaries
export const INNER_LEFT_COLUMN_MIN_X = INNER_ZONE_LEFT_EDGE_X;
export const INNER_LEFT_COLUMN_MAX_X = -2.27;

export const INNER_CENTER_COLUMN_MIN_X = -2.26;
export const INNER_CENTER_COLUMN_MAX_X = 2.26;

export const INNER_RIGHT_COLUMN_MIN_X = 2.27;
export const INNER_RIGHT_COLUMN_MAX_X = INNER_ZONE_RIGHT_EDGE_X;

// Outer edge zone boundaries
export const OUTER_EDGE_TOP_MIN_Y = 2.625;
export const OUTER_EDGE_TOP_MAX_Y = 3.73;

export const OUTER_EDGE_BOTTOM_MIN_Y = 1.52;
export const OUTER_EDGE_BOTTOM_MAX_Y = 2.625;

export const OUTER_EDGE_LEFT_BOUNDARY_X = -0.83;
export const OUTER_EDGE_RIGHT_BOUNDARY_X = 0.83;

// Area boundaries
export const AREA_MIN_X = -10;
export const AREA_MAX_X = 10;
export const AREA_CENTER_X = 0;
export const AREA_CENTER_Y = 0;
